import { logger } from "@/modules/common/logging/logger";
import { ILoadCarrierService } from '@/modules/loadCarriers/service/ILoadCarrierService';

export class LoadCarrierServiceLogDecorator implements ILoadCarrierService {
  private readonly decoree: ILoadCarrierService;

  constructor(decoree: ILoadCarrierService) {
    this.decoree = decoree;
  }

  async loadLoadCarriers(): Promise<void> {
    const start = this.logStart('loadLoadCarriers');
    await this.decoree.loadLoadCarriers();
    this.logEnd('loadLoadCarriers', start);
  }

  //
  // private utility methods
  //

  private logStart(methodName: string): number {
    const start: number = performance.now();
    logger.info(`Start -> ${methodName}`);
    return start;
  }

  private logEnd(methodName: string, start: number): void {
    logger.info(`End -> ${methodName} (${(performance.now() - start).toFixed(2)}ms)`);
  }
}